import React from "react"


import { isLeader, isAmbassador, isAmbassadorActive, LOCAL_USER_ID, setItem, LOCAL_AMBASSADOR_ID, clearStorage, LOCAL_USER_ROLES_TEXT, KEY_USER_ID, KEY_USER_NAME, KEY_USER_PHOTO, KEY_MODULES, KEY_ACTIVE_ROL, KEY_AMBASSADOR_ID, LOCAL_USER_ROLES, LOCAL_ACTIVE_ROL } from "../../utils/storage"
import { Radio } from "antd"
import { ROLE_AMBASSADOR, ROLE_LEADER, TYPE_SURVEY } from "../../utils/constants"
import "./index.less"

export class RoleSelector extends React.Component {


    state = {
        isLoadingChangeRole: false
    }

    changeSelect = (role) => {
        this.changeRoleProfile(role)
    }

    changeRoleProfile = async (role) => {
        try {
            this.setState({ isLoadingChangeRole: true })
            const result = await fetchGlobalApi({
                method: "POST",
                endpoint: `users/${LOCAL_USER_ID()}/change-role`,
                data: { id_role: role },
            })
            const { user } = result.data.data.result
            setItem(KEY_USER_ID, user.id)
            setItem(KEY_USER_NAME, user.name)
            setItem(KEY_USER_PHOTO, user.picture_profile)
            setItem(KEY_MODULES, JSON.stringify(user.modules))
            setItem(KEY_ACTIVE_ROL, user.id_role)
            this.setState({ isLoadingChangeRole: false })
            if (user.id_role === ROLE_AMBASSADOR || user.id_role === ROLE_LEADER) {

                if (validRole({ role: [5] })) {
                    setItem(KEY_AMBASSADOR_ID, user.id_ambassador)
                    // return window.location.replace(`/reports/dashboard`)
                }
                
            }

            if(this.props.sourcePage === 'pdas') {
                return window.location.replace(`/action-plans`)
            }

            if(this.props.sourcePage === 'reports') {
                return window.location.replace(`/reports/dashboard`)
            }

            return window.location.replace("/reports/dashboard")
        } catch (error) {
            this.setState({ isLoadingChangeRole: false })
            console.log(error)
            if (error.response.status === CODE_FETCHING.error.Unauthorized) {
                clearStorage()
                window.location.replace("/login")
            }
            returnMessage(error)
        }
    }

    onChange = (e) => {
        this.changeRoleProfile(e.target.value)
    };
    
    render () {

        const isIframe = window.top !== window.self
        const roles = JSON.parse(LOCAL_USER_ROLES())
        const rolesIds  = roles.map((role) => role.id)
        let ambassadorFieldText = 'Embajador'

        if(roles.length === 1 || !isIframe) {
            return <></>
        }

        if(rolesIds.length === 2 && 
          (rolesIds.includes(ROLE_AMBASSADOR) && rolesIds.includes(ROLE_LEADER))
        ) {
            return <></>
        }

        if(rolesIds.length === 2 && (rolesIds.includes(ROLE_LEADER)) && this.props.sourcePage == 'pdas') {
            return <></>
        }
        
          
        let activeRole = parseInt(LOCAL_ACTIVE_ROL())


        if(rolesIds.includes(6) && this.props.sourcePage !== 'pdas') {
            ambassadorFieldText = 'Embajador / Líder'
        }

        let superAdminValue = rolesIds.includes(1) ? 1 : 2
        
        const roleOptions = []

        
        if (rolesIds.includes(1) || rolesIds.includes(2)) {
        roleOptions.push({ label: "Administrador", value: superAdminValue })
        }

    
        if (rolesIds.includes(5)) {
        roleOptions.push({ label: ambassadorFieldText, value: 5 })
        }

        if (rolesIds.includes(6) & !rolesIds.includes(5) && this.props.sourcePage !== 'pdas') {
        roleOptions.push({ label: "Líder", value: 6 })
        }
        
        return (<>
            <div className="role-selector">
                <span className="role-selector-text">Ver como</span>
                <Radio.Group
                    options={roleOptions}
                    onChange={this.onChange}
                    optionType="button"
                    buttonStyle="solid"
                    defaultValue={parseInt(activeRole)}
                    disabled={this.state.isLoadingChangeRole}
                />
            </div>
        </>)
        /*
        return (
            (LOCAL_USER_ROLES_TEXT().includes("Administrador") || LOCAL_USER_ROLES_TEXT().includes("Superadministrador")) &&
                LOCAL_USER_ROLES_TEXT().includes("Embajador")
                    && (
                <Select style={{marginBottom: 15}} onChange={this.changeSelect} width={200} defaultValue="Administrador">
                    <Option key={1} value={1}>Administrador</Option>
                    <Option key={2} value={5}>Embajador</Option>
                </Select>
            )
        )
        */
    }
}